var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-checkbox',{staticClass:"ma-0 pa-0",attrs:{"label":_vm.$t('assemblyPlanning.starredPlans')},model:{value:(_vm.starred),callback:function ($$v) {_vm.starred=$$v},expression:"starred"}})
}
var staticRenderFns = []

export { render, staticRenderFns }